import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Footer } from '../components/Footer';
import { ArrowLeft, Bell, Lock, User, CreditCard, Shield } from 'lucide-react';
import { ChangePasswordModal } from '../components/modals/ChangePasswordModal';
import { Setup2FAModal } from '../components/modals/Setup2FAModal';
export function SettingsPage() {
  const [isPasswordModalOpen, setIsPasswordModalOpen] = useState(false);
  const [is2FAModalOpen, setIs2FAModalOpen] = useState(false);
  const [settings, setSettings] = useState({
    emailNotifications: true,
    smsNotifications: false,
    inquiryAlerts: true,
    marketingEmails: false
  });
  return <div data-testid="settings-page" className="min-h-screen bg-[#f5f5f7] font-sans text-[#1f2933] flex flex-col" data-id="element-5676">
      <header data-testid="settings-header" className="bg-white border-b border-gray-300 py-4 px-6 md:px-12" data-id="element-5677">
        <div className="max-w-7xl mx-auto flex justify-between items-center" data-id="element-5678">
          <Link data-testid="settings-logo-link" to="/" className="flex items-center gap-2" data-id="element-5679">
            <div className="w-8 h-8 bg-[#1f2933] rounded-sm" data-id="element-5680"></div>
            <span className="font-bold text-xl tracking-tight" data-id="element-5681">
              Citiplots.com
            </span>
          </Link>
        </div>
      </header>

      <main data-testid="settings-main" className="flex-1 max-w-4xl mx-auto px-6 py-12 w-full" data-id="element-5682">
        <Link data-testid="settings-back-link" to="/dashboard" className="flex items-center gap-2 text-sm text-gray-600 hover:text-gray-900 mb-6" data-id="element-5683">
          <ArrowLeft className="w-4 h-4" data-id="element-5684" />
          Back to Dashboard
        </Link>

        <h1 data-testid="settings-title" className="text-3xl font-bold mb-8" data-id="element-5685">
          Account Settings
        </h1>

        <div data-testid="settings-profile-section" className="bg-white border border-gray-300 p-8 mb-6" data-id="element-5686">
          <h2 className="font-bold text-lg mb-6 pb-2 border-b border-gray-200 flex items-center gap-2" data-id="element-5687">
            <User className="w-5 h-5" data-id="element-5688" />
            Profile Information
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-5689">
            <div data-id="element-5690">
              <label className="block text-sm font-bold text-gray-700 mb-1" data-id="element-5691">
                Full Name
              </label>
              <input data-testid="settings-name-input" type="text" defaultValue="John Doe" className="w-full p-2 border border-gray-300 bg-gray-50 focus:outline-none focus:border-gray-500" data-id="element-5692" />
            </div>
            <div data-id="element-5693">
              <label className="block text-sm font-bold text-gray-700 mb-1" data-id="element-5694">
                Email
              </label>
              <input data-testid="settings-email-input" type="email" defaultValue="john@example.com" className="w-full p-2 border border-gray-300 bg-gray-50 focus:outline-none focus:border-gray-500" data-id="element-5695" />
            </div>
            <div data-id="element-5696">
              <label className="block text-sm font-bold text-gray-700 mb-1" data-id="element-5697">
                Phone
              </label>
              <input data-testid="settings-phone-input" type="tel" defaultValue="+91 98765 43210" className="w-full p-2 border border-gray-300 bg-gray-50 focus:outline-none focus:border-gray-500" data-id="element-5698" />
            </div>
            <div data-id="element-5699">
              <label className="block text-sm font-bold text-gray-700 mb-1" data-id="element-5700">
                Location
              </label>
              <input data-testid="settings-location-input" type="text" defaultValue="Mumbai, Maharashtra" className="w-full p-2 border border-gray-300 bg-gray-50 focus:outline-none focus:border-gray-500" data-id="element-5701" />
            </div>
          </div>
          <div className="mt-6 flex justify-end" data-id="element-5702">
            <button data-testid="settings-save-profile-btn" className="px-6 py-2 bg-[#1f2933] text-white text-sm font-bold hover:bg-gray-800" data-id="element-5703">
              Save Changes
            </button>
          </div>
        </div>

        <div data-testid="settings-security-section" className="bg-white border border-gray-300 p-8 mb-6" data-id="element-5704">
          <h2 className="font-bold text-lg mb-6 pb-2 border-b border-gray-200 flex items-center gap-2" data-id="element-5705">
            <Shield className="w-5 h-5" data-id="element-5706" />
            Security
          </h2>
          <div className="space-y-4" data-id="element-5707">
            <div data-testid="settings-password-item" className="flex items-center justify-between p-4 border border-gray-200 bg-gray-50" data-id="element-5708">
              <div data-id="element-5709">
                <div className="font-bold text-sm mb-1" data-id="element-5710">Password</div>
                <div className="text-xs text-gray-500" data-id="element-5711">
                  Last changed 2 months ago
                </div>
              </div>
              <button data-testid="settings-change-password-btn" onClick={() => setIsPasswordModalOpen(true)} className="px-4 py-2 border border-gray-300 text-sm font-bold hover:bg-white" data-id="element-5712">
                Change Password
              </button>
            </div>
            <div data-testid="settings-2fa-item" className="flex items-center justify-between p-4 border border-gray-200 bg-gray-50" data-id="element-5713">
              <div data-id="element-5714">
                <div className="font-bold text-sm mb-1" data-id="element-5715">
                  Two-Factor Authentication
                </div>
                <div className="text-xs text-gray-500" data-id="element-5716">
                  Add extra security to your account
                </div>
              </div>
              <button data-testid="settings-enable-2fa-btn" onClick={() => setIs2FAModalOpen(true)} className="px-4 py-2 bg-[#1f2933] text-white text-sm font-bold hover:bg-gray-800" data-id="element-5717">
                Enable 2FA
              </button>
            </div>
          </div>
        </div>

        <div data-testid="settings-notifications-section" className="bg-white border border-gray-300 p-8" data-id="element-5718">
          <h2 className="font-bold text-lg mb-6 pb-2 border-b border-gray-200 flex items-center gap-2" data-id="element-5719">
            <Bell className="w-5 h-5" data-id="element-5720" />
            Notification Preferences
          </h2>
          <div className="space-y-4" data-id="element-5721">
            <label data-testid="settings-email-notifications" className="flex items-center justify-between p-3 border border-gray-200 hover:bg-gray-50 cursor-pointer" data-id="element-5722">
              <div data-id="element-5723">
                <div className="font-bold text-sm" data-id="element-5724">Email Notifications</div>
                <div className="text-xs text-gray-500" data-id="element-5725">
                  Receive updates via email
                </div>
              </div>
              <input data-testid="settings-email-notifications-toggle" type="checkbox" checked={settings.emailNotifications} onChange={e => setSettings({
              ...settings,
              emailNotifications: e.target.checked
            })} className="w-4 h-4 accent-[#1f2933]" data-id="element-5726" />
            </label>
            <label data-testid="settings-sms-notifications" className="flex items-center justify-between p-3 border border-gray-200 hover:bg-gray-50 cursor-pointer" data-id="element-5727">
              <div data-id="element-5728">
                <div className="font-bold text-sm" data-id="element-5729">SMS Notifications</div>
                <div className="text-xs text-gray-500" data-id="element-5730">
                  Receive updates via SMS
                </div>
              </div>
              <input data-testid="settings-sms-notifications-toggle" type="checkbox" checked={settings.smsNotifications} onChange={e => setSettings({
              ...settings,
              smsNotifications: e.target.checked
            })} className="w-4 h-4 accent-[#1f2933]" data-id="element-5731" />
            </label>
          </div>
        </div>
      </main>

      <Footer data-id="element-5732" />

      <ChangePasswordModal isOpen={isPasswordModalOpen} onClose={() => setIsPasswordModalOpen(false)} data-id="element-5733" />
      <Setup2FAModal isOpen={is2FAModalOpen} onClose={() => setIs2FAModalOpen(false)} data-id="element-5734" />
    </div>;
}